import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useLayoutEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router";
import SideMenuItemsForRole from "./SideMenuItemsForRole";
import { PageHeaderSlotProvider } from "./PageHeaderSlotContext";

export const AppLayout = () => {
  const navigate = useNavigate();
  const headerSlotRef = useRef<HTMLDivElement | null>(null);
  const [slotReady, setSlotReady] = useState(false);

  useLayoutEffect(() => {
    if (headerSlotRef.current && !slotReady) setSlotReady(true);
  });

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <PageHeaderSlotProvider headerSlotRef={headerSlotRef} slotReady={slotReady}>
      <SidebarProvider defaultOpen={false}>
        <div className="h-screen flex w-full">
          <Sidebar className="bg-gray-100">
            <SidebarContent>
              <SidebarGroup>
                <SidebarGroupContent>
                  <SideMenuItemsForRole />
                </SidebarGroupContent>
              </SidebarGroup>
            </SidebarContent>
          </Sidebar>
          <main className="flex-1 flex flex-col min-h-0 min-w-0">
            <div className="flex items-center flex-shrink-0 px-2 py-1.5 bg-primary text-primary-foreground">
              <SidebarTrigger className="mr-4 text-primary-foreground hover:bg-primary-foreground/20" />
              <Button
                variant="ghost"
                size="icon"
                onClick={handleBack}
                className="mr-2 text-primary-foreground hover:bg-primary-foreground/20"
                title="Go back"
              >
                <ArrowLeft className="h-4 w-4" />
              </Button>
              <div ref={headerSlotRef} className="flex-1 min-w-0 flex items-center" />
            </div>
            <div className="flex-1 min-h-0 overflow-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </SidebarProvider>
    </PageHeaderSlotProvider>
  );
};
